export default __webpack_public_path__ + "static/media/logo17.a454926d.svg";